var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDoor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 66,
    viewBox: "0 0 51 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 9.00684,
    y: 3,
    width: 38,
    height: 52,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.4777 0H10.0922C9.24459 0 8.55687 0.687842 8.55687 1.53537V24.4904H10.6687C10.0338 23.6796 9.6889 22.6862 9.6889 21.6407C9.68814 20.4023 10.1709 19.238 11.0471 18.3626C11.2273 18.1823 11.4242 18.0218 11.6284 17.8749V3.07087H46.9422V4.17398L30.8206 15.8792V65.9999L47.03 54.231C47.2362 54.836 47.8319 55 48.5066 55C49.3545 55 50.0131 54.5863 50.0131 53.7392V1.53537C50.0131 0.687081 49.3255 0 48.4777 0ZM36.9111 42.1068C36.1869 42.1068 35.5834 41.2131 35.4283 40.0158H33.6995V38.6724H35.4522C35.6359 37.5486 36.2154 36.7216 36.9096 36.7216C37.7515 36.7216 38.433 37.9263 38.433 39.4145C38.4346 40.9012 37.7523 42.1068 36.9111 42.1068ZM11.0477 39.8869C11.2283 40.0659 11.424 40.2265 11.6276 40.3719V53.7392C11.6276 54.5865 10.8537 55 10.0066 55C9.15893 55 8.55687 54.5863 8.55687 53.7392V33.7565H10.6687C9.24991 35.5737 9.3751 38.2126 11.0477 39.8869ZM22.0299 27.6995C22.6408 28.3105 22.6408 29.2987 22.0299 29.9097L14.547 37.3932C14.2423 37.6969 13.8423 37.8505 13.4424 37.8512C13.0425 37.8505 12.6424 37.6983 12.3377 37.3932C11.7274 36.7822 11.7282 35.7934 12.3377 35.1838L17.1542 30.3669H1.56201C0.699131 30.3669 0 29.6678 0 28.8049C0 27.942 0.69837 27.2425 1.56277 27.2425H17.1533L12.3375 22.426C11.7281 21.8165 11.7273 20.8268 12.3375 20.2173C12.9479 19.607 13.9375 19.607 14.5477 20.2173L22.0299 27.6995Z",
    fill: "#124F6A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoor);
export default __webpack_public_path__ + "static/media/door.9fb5cd93a28419e693cb008411a72673.svg";
export { ForwardRef as ReactComponent };